export default __webpack_public_path__ + "static/media/how_to_participate.eae78cfd.png";